import { AxiosRequestConfig } from 'axios'

import { transformAuthUserJsonResponse } from 'utils/authLoginResponse'

import { LoginPayload } from './types'

const login = (payload: LoginPayload): AxiosRequestConfig => ({
  url: '/auth/login/employee',
  method: 'POST',
  data: payload,
  transformResponse: [transformAuthUserJsonResponse],
})

export { login }
